// src/lib/windgram/contours.js
import { contours } from 'd3-contour';
import { convertUnit } from './scales';
import { centeredBandConfig } from './bandConfig';

// cellValue: how one altitude slice becomes a grid number for `variable`.
// Mirrors bundle lines 1140-1163: ti/overview/cldcover → ti field;
// temperature → temp; wind → √(u²+v²); lapserate → lapse; rh → rh; cldfra → cldfra.
function cellValue(slice, variable, units) {
  switch (variable) {
    case 'ti':
    case 'overview':
    case 'cldcover': return convertUnit(parseFloat(slice.ti), units.vert);
    case 'temperature': return convertUnit(parseFloat(slice.temp), units.temp);
    case 'wind': return convertUnit(Math.hypot(parseFloat(slice.u), parseFloat(slice.v)), units.spd);
    case 'lapserate': return parseFloat(slice.lapse);
    case 'rh': return parseFloat(slice.rh);
    case 'cldfra': return parseFloat(slice.cldfra);
    default: return parseFloat(slice[variable]);
  }
}

// buildGrid: row-flipped (top row = highest altitude) row-major grid.
// Formula (height-1-g)*width + c mirrors bundle lines 1140-1163.
// g=0 (lowest altitude slice) → bottom row; g=height-1 (highest) → top row (index 0).
export function buildGrid(timeSteps, variable, units = {}) {
  const width = timeSteps.length;
  const height = timeSteps[0].data.length;
  const values = new Array(width * height);
  for (let g = 0; g < height; g++) {
    for (let c = 0; c < width; c++) {
      values[(height - 1 - g) * width + c] = cellValue(timeSteps[c].data[g], variable, units);
    }
  }
  return { values, width, height };
}

// buildContours: build d3-contour polygons for `variable` using the given scale's thresholds.
export function buildContours(timeSteps, variable, scale, units = {}) {
  const { values, width, height } = buildGrid(timeSteps, variable, units);
  const { thresholds } = centeredBandConfig(variable, scale);
  return contours().size([width, height]).thresholds(thresholds).smooth(true)(values);
}
